module.exports = __webpack_public_path__ + "img/default-institution.c48581cc.png";